export { SEARCH_HITS_PER_PAGE, getCumulativeSearchHitsPerPage } from './constants';

export {
  isValidTab,
  VALID_TABS,
  fetchSearchResults,
  type SearchTab,
  type TabSearchResult,
} from './fetchSearchResults';

export { fetchSearchCounts, type SearchCounts } from './fetchSearchCounts';

export { transformHitToProductCard, transformHitsToProductCards } from './transformHits';

export { fetchBatchSearch, type BatchSearchSuggestionsResult } from './fetchBatchSearch';
